/**
 * Masking for a phone number shown back to the person who owns it.
 *
 * 🔴 ITS OWN MODULE FOR A FAST REFRESH REASON, NOT AN ARCHITECTURAL ONE.
 * `EntryScreens.tsx` exported this alongside four screen components, and a
 * module that exports both components and a plain function cannot be hot
 * swapped: vite-plugin-react reports `Could not Fast Refresh ("maskPhone"
 * export is incompatible)` and invalidates the whole module instead. Every edit
 * to the largest auth screen in the app therefore cost a full page reload, and
 * took the half-filled sign-in form with it.
 *
 * ⚠️ IT CANNOT SIMPLY BE UN-EXPORTED, which was the smaller-looking fix.
 * `consent/consent.test.ts` imports it by name and is the only coverage this
 * function has — the rule it encodes is a disclosure decision, so making the
 * export private to silence a build warning would trade a real guarantee away.
 */

/**
 * Last two digits only — enough to recognise, not enough to disclose.
 *
 * ⚠️ NOT THE SAME FUNCTION AS `roster/importModel.ts`'s `maskPhone`, despite the
 * name. That one keeps FOUR digits behind a `+91` because a school admin is
 * reconciling a parent's number against their own list and needs to tell two
 * families apart. This one is shown to the person who owns the number, who only
 * has to recognise it — so it discloses less, deliberately. Two different
 * decisions that happen to share a name; merging them would quietly loosen one.
 */
export function maskPhone(phone: string): string {
  const digits = phone.replace(/\D/g, "");
  if (digits.length < 2) return "••";
  return `•••••${digits.slice(-2)}`;
}
